var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/Nut/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import pt from 'prop-types';
import { nutGraphic } from './../../../Fretboard/Skins/skins';
import ViewPort from './../../../Fretboard/Neck/ViewPort';

const Nut = ({
  tuning,
  width,
  offset,
  skinType
}) => {
  const NutGraphic = nutGraphic(skinType);
  const nrOfStrings = tuning.length;
  return /*#__PURE__*/React.createElement(ViewPort, _extends({
    width,
    offset
  }, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(NutGraphic, {
    nrOfStrings: nrOfStrings,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }));
};

Nut.propTypes = {
  tuning: pt.arrayOf(pt.string).isRequired,
  width: pt.number.isRequired,
  offset: pt.number.isRequired,
  skinType: pt.string.isRequired
};
export default Nut;